import * as Clipboard from 'expo-clipboard';

const ClipboardService = {
	async copyToClipboard({ text }: { text: string }): Promise<void> {
		await Clipboard.setStringAsync(text);
	},

	readFromClipboard(): Promise<string> {
		return Clipboard.getStringAsync();
	},
};

export default ClipboardService;
